import { useState } from 'react';
import { Small } from 'palette/Typography';
import ActiveFilterButton from '@common/Filters/components/ActiveFilterButton';
import { ToggleFiltersVisibilityButton } from '@common/Filters/components/ToggleFiltersVisibilityButton';
import { LIMIT } from '@common/Filters/containers/ActiveFilters';
import { BEMBlock } from '@helpers/classnames';
import './ActiveFiltersGroup.scss';

export function ActiveFiltersGroup({
    filters, onFilterClick, groupLabel
}) {
    const [displayAllFilters, setDisplayAllFilters] = useState(false);

    const [, BEMElement] = BEMBlock('active-filters-group');

    const visibleFilters = (!displayAllFilters && filters.length > LIMIT)
        ? filters.slice(0, LIMIT)
        : filters;

    const handleToggleAllFiltersButtonClick = () => {
        setDisplayAllFilters(prev => !prev);
    };

    return (
        <>
            {
                !!groupLabel && (
                    <Small
                        className={BEMElement('caption')}
                        color="light"
                        tagName="p"
                        transform="uppercase"
                    >
                        {groupLabel}
                    </Small>
                )
            }
            {
                visibleFilters.map((filter) => {
                    const { filterType, value } = filter;
                    return (
                        <ActiveFilterButton
                            key={filterType + value}
                            activeFilter={filter}
                            className="mr-8 mb-8"
                            filterClick={onFilterClick}
                            theme="mod1"
                        />
                    );
                })
            }
            {
                filters.length > LIMIT && (
                    <ToggleFiltersVisibilityButton
                        displayAllFilters={displayAllFilters}
                        hiddenElements={filters.length - LIMIT}
                        onClick={handleToggleAllFiltersButtonClick}
                    />
                )
            }
        </>
    );
}
